import { render, staticRenderFns } from "./CopyProfilesUsers.vue?vue&type=template&id=32964670&scoped=true&"
import script from "./CopyProfilesUsers.vue?vue&type=script&lang=js&"
export * from "./CopyProfilesUsers.vue?vue&type=script&lang=js&"
import style0 from "./CopyProfilesUsers.vue?vue&type=style&index=0&id=32964670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32964670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32964670')) {
      api.createRecord('32964670', component.options)
    } else {
      api.reload('32964670', component.options)
    }
    module.hot.accept("./CopyProfilesUsers.vue?vue&type=template&id=32964670&scoped=true&", function () {
      api.rerender('32964670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/CopyProfilesUsers.vue"
export default component.exports